module.exports = __webpack_public_path__ + "img/c06_unitbireme_Normal_ua.1a1f1df2.webp";